import React from 'react';
import { useDispatch } from 'react-redux';
import {
    actionCreators as aiActionCreators
} from '../../../../store/StateControllers/Survey/SurveyResponse/AISurveyAgentController';
import { useLocalizer } from '../hooks/useLocalizer';

interface ProcessNewDocumentsButtonProps {
    onProcessNewDocuments?: () => void;
    setErrorMessage: (message: string | null) => void;
}

export const ProcessNewDocumentsButton: React.FC<ProcessNewDocumentsButtonProps> = ({
    onProcessNewDocuments,
    setErrorMessage
}) => {
    const localize = useLocalizer();
    const dispatch = useDispatch();
    const [isOpeningUpload, setIsOpeningUpload] = React.useState(false);

    const processNewDocuments = () => {
        try {
            setIsOpeningUpload(true);
            setErrorMessage(null);

            dispatch(aiActionCreators.clearAIOperation() as any);
            onProcessNewDocuments?.();
        } catch {
            setIsOpeningUpload(false);
            setErrorMessage(localize('Sorry, there was a problem opening the new documents for processing. Please try again.'));
        }
    };

    return (
        <button
            type="button"
            className="btn btn-toxnot-primary gap-summary-process-new-documents"
            disabled={isOpeningUpload || !onProcessNewDocuments}
            onClick={processNewDocuments}
        >
            {localize('Process new documents')}
        </button>
    );
};

export default ProcessNewDocumentsButton;
